import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { useMobile } from '../hooks/useMobile';
import { Link } from 'react-router-dom';

import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/useAuthStore';

export const IndividualForm = () => {
    const isMobile = useMobile();
    const navigate = useNavigate();
    const signup = useAuthStore(state => state.signup);

    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        phoneNumber: '',
        password: '',
        confirmPassword: ''
    });
    
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        if (error) setError('');
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        
        if (!formData.fullName || !formData.email || !formData.password) {
            setError('Please fill in all required fields');
            return;
        }

        if (formData.password !== formData.confirmPassword) {
            setError('Passwords do not match');
            return;
        }

        if (formData.password.length < 8) {
            setError('Password must be at least 8 characters');
            return;
        }

        const result = signup(formData);
        
        if (result.success) {
            navigate('/home'); // Change this to whatever your protected route is
        } else {
            //email already exists
            setError(result.message || 'Signup failed email already registered login instead');
        }
    };

    const labelStyle: React.CSSProperties = {
        display: 'block',
        marginBottom: '8px',
        fontSize: '14px',
        fontWeight: '700',
        color: '#4B5563',
        fontFamily: 'Manrope, sans-serif',
        textAlign: 'left'
    };

    const inputStyle: React.CSSProperties = {
        width: '100%',
        padding: '12px',
        borderRadius: '8px',
        border: 'none',
        color: '#1F2933',
        fontSize: '16px',
        outline: 'none',
        backgroundColor: '#E6E8EC',
        boxSizing: 'border-box',
    };

    const passwordInputStyle: React.CSSProperties = {
        ...inputStyle,
        paddingRight: '45px'
    };

    const iconContainerStyle: React.CSSProperties = {
        position: 'absolute',
        right: '12px',
        top: '50%',
        transform: 'translateY(-50%)',
        cursor: 'pointer',
        color: '#6B7280',
        display: 'flex',
        alignItems: 'center'
    };

    return (
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%', marginTop: '30px' }}>
            <div>
                <label style={labelStyle}>Full Name</label>
                <input 
                    name="fullName"
                    type="text" 
                    placeholder="your full name" 
                    style={inputStyle} 
                    onChange={handleChange}
                />
            </div>
            
            <div style={{ display: isMobile ? 'block' : 'flex', gap: '16px' }}>
                <div style={{ flex: 1 }}>
                    <label style={labelStyle}>Email</label>
                    <input 
                        name="email"
                        type="email" 
                        placeholder="eddy****@gmail.com" 
                        style={inputStyle} 
                        onChange={handleChange}
                    />
                </div>
                <div style={{ flex: 1, marginTop: isMobile ? '20px' : '0px' }}>
                    <label style={labelStyle}>Phone Number</label>
                    <input 
                        name="phoneNumber"
                        type="text" 
                        placeholder="07078***740" 
                        style={inputStyle} 
                        onChange={handleChange}
                    />
                </div> 
            </div>

            <div>
                <label style={labelStyle}>Password</label>
                <div style={{ position: 'relative' }}>
                    <input 
                        name="password"
                        type={showPassword ? "text" : "password"} 
                        placeholder="Enter Password" 
                        style={passwordInputStyle} 
                        onChange={handleChange}
                    />
                    <div onClick={() => setShowPassword(!showPassword)} style={iconContainerStyle}>
                        {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                    </div>
                </div>
            </div>

            <div>
                <label style={labelStyle}>Confirm Password</label>
                <div style={{ position: 'relative' }}>
                    <input 
                        name="confirmPassword"
                        type={showConfirmPassword ? "text" : "password"} 
                        placeholder="Enter Password" 
                        style={passwordInputStyle} 
                        onChange={handleChange}
                    />
                    <div onClick={() => setShowConfirmPassword(!showConfirmPassword)} style={iconContainerStyle}>
                        {showConfirmPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                    </div>
                </div>
            </div>

            {error && (
                <p style={{ display: 'block', color: '#EF4444', fontSize: '12px', margin: 0, fontFamily: 'Manrope, sans-serif' }}>
                    {error}
                </p>
            )}

            <button 
                type="submit"
                style={{
                    width: '100%',
                    padding: '14px',
                    backgroundColor: '#1A2238',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '16px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    marginTop: '30px',
                    fontFamily: 'Manrope, sans-serif'
                }}
            >
                Create Account
            </button>
            <div style={{ display: 'flex', alignItems: 'center', margin: 'auto', fontFamily: 'Manrope, sans-serif', fontWeight: '500' }}>
                <p style={{ color: '#4B5563B2', fontSize: '16px' }}>Already have an account?</p>
                <Link to="/login" style={{ fontSize: '20px', color: '#C8A95B', textDecoration: 'none', marginLeft: '5px' }}>Log in</Link>
            </div>
        </form>
    );
}